import React, {Component} from 'react';

class GenericNavbar extends Component{
    render()
    {
        return(
            <nav className="nav-wrapper grey darken-4 navbar">
            <div className="container-fluid">
            <a href="/" className="brand-logo">
                        <img
                            className="header__logo"
                            src="./logo.jpg"
                            alt="logo"
                            />
                            </a>
               <ul className = "right">
                   {/* <li><a href = "/sender">Sender</a></li>
                    <li active><a href = "/recipient">Recipient</a></li>
                    <li><a href = "/newRecord">Request Record</a></li>
                   <li active><a href = "/token">Token</a></li>
                   <li active><a href = "/coin">Coin</a></li>
                   <li active><a href = "/nft">NFT</a></li>
                   <li><a href = "/">Log out</a></li>  */}
               </ul>
            </div>
        </nav>
        )
    }

}

export default GenericNavbar;
